import { render, staticRenderFns } from "./MessageboxCount.vue?vue&type=template&id=f7d160de"
import script from "./MessageboxCount.vue?vue&type=script&lang=js"
export * from "./MessageboxCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports